export default __webpack_public_path__ + "static/media/gallery-wip-blade plug_05.090c9567.jpg";